import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography
} from '@material-ui/core';
import Selector from '../Selector';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const CreateAutomationFilters = observer(({ automationStore }) => {
  const [count, setCount] = useState(0);
  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <Typography>
            <h3>Data de criação da conta</h3>
          </Typography>
          <Selector id='account_creation_date' label='Data de criação da conta' date
                    automationStore={automationStore} />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Data do último acesso</h3>
          </Typography>
          <Selector id='last_access_date' label='Data de último acesso' date automationStore={automationStore} />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Data do último trecho</h3>
          </Typography>
          <Selector id='last_quote_date' label='Data do último trecho' date automationStore={automationStore} />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Data de nascimento</h3>
          </Typography>
          <Selector id='birth_date' label='Data de nascimento' date automationStore={automationStore} />
        </Grid>
      </Grid>
      <br /><br />
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <Typography>
            <h3>Qtde. de trechos criados</h3>
          </Typography>
          <Selector id='quote_count' label='Qtde. de trechos criados' automationStore={automationStore} />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Qtde. de livros na wishlist</h3>
          </Typography>
          <Selector id='wishlist_count' label='Qtde. de livros na wishlist' automationStore={automationStore} />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Privacidade do perfil</h3>
          </Typography>
          <FormControl fullWidth>
            <Select id='profile_privacy' value={automationStore.filters.profile_privacy}
                    onChange={e => {
                      automationStore.setFilter('profile_privacy', null, e.target.value);
                      setCount(count + 1);
                    }}>
              <MenuItem value='all'>Todos</MenuItem>
              <MenuItem value='public'>Público</MenuItem>
              <MenuItem value='private'>Privado</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Typography>
            <h3>Já recebeu interação</h3>
          </Typography>
          <FormControl id='has_interaction' fullWidth>
            <Select value={automationStore.filters.has_interaction}
                    onChange={e => automationStore.setFilter('has_interaction', null, e.target.value)}>
              <MenuItem value='all'>Tanto faz</MenuItem>
              <MenuItem value='no'>Não</MenuItem>
              <MenuItem value='yes'>Sim</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <br /><br />
      <Grid container spacing={4} justifyContent='flex-end'>
        <Grid item xs={12}>
          <Box display='flex' justifyContent='flex-end'>
            <Button variant='contained' onClick={async (e) => {
              await automationStore.saveFilters();
            }}>Aplicar Filtros</Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
});

export default CreateAutomationFilters;
